import { useQuery } from "@tanstack/react-query";
import { fetchClient } from "../../API/fetchClient";

export interface EsgPillar {
  id: number;
  code: string;
  name: string;
}

export interface EsgTheme {
  id: number;
  pillar: EsgPillar;
  name: string;
}

export interface GriStandard {
  id: number;
  code: string;
}

export interface Sdg {
  id: number;
  code: string;
  title: string;
}

export interface EsgIndicator {
  id: number;
  theme: EsgTheme;
  name: string;
  measure_type: "quantitative" | "qualitative";
  frequency: "annual" | "semiannual";
  data_source: string;
  remarks: string;
  cgem_label: string;
  is_active: boolean;
  gri_standards: GriStandard[];
  sdgs: Sdg[];
  created_at: string;
  updated_at: string;
}

type MaybePagedResponse<T> = T[] | { results: T[]; count: number };

export const useGetEsgIndicators = () =>
  useQuery({
    queryKey: ["esg-indicators"],
    queryFn: async (): Promise<EsgIndicator[]> => {
      const resp = await fetchClient<MaybePagedResponse<EsgIndicator>>(
        "/core/esg/indicators/?page_size=200&is_active=true"
      );
      if (resp.error || !resp.data) throw resp.error || new Error("Failed to fetch ESG indicators");
      if (Array.isArray(resp.data)) return resp.data;
      return resp.data.results;
    },
    staleTime: 10 * 60 * 1000,
  });
